import { WHATSAPP_TEMPLATE_HEADER_FORMATS, WHATSAPP_TEMPLATE_PARAMETER_FORMATS } from 'cpool-constants';
import { z } from 'zod';

import { schemaWhatsAppTemplateButton } from './schemaWhatsAppTemplateButton';

/** Single APPROVED template row as synced from Meta (Meta fields only — no vocabulary derivation). */
export const schemaWhatsAppCatalogTemplate = z.object({
    bodyText: z.string(),
    // Never `.default([])`: an absent array must stay distinguishable from a button-less template.
    buttons: z.array(schemaWhatsAppTemplateButton).optional(),
    category: z.string().min(1),
    hasButtonVars: z.boolean(),
    hasHeaderVars: z.boolean(),
    // Absent = no header. Non-TEXT formats are blocked at send time (they'd look placeholder-free).
    headerFormat: z.nativeEnum(WHATSAPP_TEMPLATE_HEADER_FORMATS).optional(),
    // Absent with hasHeaderVars true = pre-header-model row (blocked in resolveTemplateParametersFromCatalog).
    headerText: z.string().optional(),
    // Positional headers number independently of the body, so `['1']` here is unrelated to the body's {{1}}.
    headerVariableNames: z.array(z.string()).optional(),
    language: z.string().min(1),
    metaTemplateId: z.string().min(1),
    parameterFormat: z.nativeEnum(WHATSAPP_TEMPLATE_PARAMETER_FORMATS),
    templateName: z.string().min(1),
    variableNames: z.array(z.string()),
});

export type Schema_WhatsAppCatalogTemplate = z.infer<typeof schemaWhatsAppCatalogTemplate>;
